import { createMiddlewareAction } from "./createMiddlewareAction"
import { endpointsBackOffice } from "../api/endpoints"
import { specialtiesTypes } from "../constantes/actionTypes"

export const specialtiesActions = {
    getAllSpecialties: () => (
        createMiddlewareAction({
            successType: specialtiesTypes.GET_ALL_SPECIALTIES_SUCCESS,
            failureType: specialtiesTypes.GET_ALL_SPECIALTIES_FAILURE,
            method: "GET",
            endpoint: endpointsBackOffice.GET_ALL_SPECIALTIES
        })
    ),
    deleteSpeciality: (id) => (
        createMiddlewareAction({
            successType: specialtiesTypes.DELETE_SPECIALTY_SUCCESS,
            failureType: specialtiesTypes.DELETE_SPECIALTY_FAILURE,
            method:"DELETE",
            endpoint: endpointsBackOffice.DELETE_SPECIALTIES(id),
        })
    ),
    updateSpeciality: (speciality) => (
        createMiddlewareAction({
            successType: specialtiesTypes.UPDATE_SPECIALTY_SUCCESS,
            failureType: specialtiesTypes.UPDATE_SPECIALTY_FAILURE,
            method: "PUT",
            endpoint: endpointsBackOffice.UPDATE_SPECIALTIES,
            body: speciality
        })
    ),
    newSpeciality: (speciality) => (
        createMiddlewareAction({
            successType: specialtiesTypes.NEW_SPECIALTY_SUCCESS,
            failureType: specialtiesTypes.NEW_SPECIALTY_FAILURE,
            method: "POST",
            endpoint: endpointsBackOffice.NEW_SPECIALTIES,
            body: speciality
        })
    )
}